import * as actionTypes from "../ActionTypes";

const initialState = {
  getLoan: [],
};

const store = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_LOAN_INIT:
      return {
        ...state,
      };
    case actionTypes.GET_LOAN_SUCCESS:
      return {
        ...state,
        getLoan: action.payload,
      };
    case actionTypes.GET_LOAN_FAIL:
      return {
        ...state,
        error: "",
      };
    default:
      return state;
  }
};

export default store;
